import { dbPost } from '../../apis/commonApi';

class ReportListController {
  headerList = [
    {
      colNo: 0,
      key: 'aplyYmd',
      labelType: 'text',
      dataType: 'text',
      name: '조사일자',
      readonly: true,
    },
    {
      colNo: 1,
      key: 'se',
      labelType: 'text',
      dataType: 'badge',
      dataOption: 'white',
      name: '조사구분',
    },
    {
      colNo: 2,
      key: 'survey',
      labelType: 'text',
      dataType: 'text',
      name: '조사작업수',
    },
    {
      colNo: 3,
      key: 'workload',
      labelType: 'text',
      dataType: 'text',
      name: '부담작업수',
    },
    {
      colNo: 4,
      key: 'aplyUser',
      labelType: 'text',
      dataType: 'text',
      name: '조사자',
    },
    {
      colNo: 5,
      key: 'category1',
      labelType: 'text',
      dataType: 'badge',
      name: '체크리스트',
    },
    {
      colNo: 6,
      key: 'category2',
      labelType: 'text',
      dataType: 'badge',
      name: '영상업로드',
    },
    {
      colNo: 7,
      key: 'category3',
      labelType: 'text',
      dataType: 'badge',
      name: '기본조사표',
    },
    {
      colNo: 8,
      key: 'category4',
      labelType: 'text',
      dataType: 'badge',
      name: '증상조사표',
    },
    {
      colNo: 9,
      key: 'category5',
      labelType: 'text',
      dataType: 'badge',
      name: '현재상태',
    },
    {
      colNo: 10,
      key: 'print',
      labelType: 'text',
      dataType: 'print',
      name: '인쇄',
    },
  ];

  constructor(
    store,
    modalService,
    validateService,
    refs,
    [searchParam, setSearchParam],
    { dataList, setDataList },
    navigate
  ) {
    this.store = store;
    this.modalService = modalService;
    this.validateService = validateService;
    this.tableRef = refs[0];
    this.searchParam = searchParam;
    this.setSearchParam = setSearchParam;
    this.dataList = dataList;
    this.setDataList = setDataList;
    this.navigate = navigate;
  }

  async init() {
    await this.setSearchParam({
      entSn: this.store.entSn,
      currentPage: 1,
      pageSize: 10,
    });
    this.fnSearch();
  }

  async fnSearch(currentPage = 1, updatedSearchParam = null) {
    const params = {
      ...(updatedSearchParam || this.searchParam),
      currentPage,
    };

    const validationRules = {
      entSn: { presence: true },
    };

    const altKey = {
      entSn: '기업',
    };

    if (
      await this.validateService.validateJsCall(params, validationRules, altKey)
    ) {
      return;
    }

    const url = '/aia/survey/list.do';

    try {
      let response = await dbPost(url, params);
      if (response && Array.isArray(response)) {
        const updatedDataList = response.map((item, index) => ({
          totalCount: item.totalCount,
          entSn: item.entSn,
          aiaAplyId: item.aiaAplyId,
          rowNo: index,

          aplyYmd: this.formatDateYYYYMMDD(item.aplyYmd),
          se: item.seNm,
          survey: item.category2Cnt1,
          workload: item.workLoadCnt,
          aplyUser: item.aplyUser,
          category1: item.category1,
          category2: item.category2,
          category3: item.category3,
          category4: item.category4,
          category5: item.category5,
          maxDanger: item.maxDanger,
          print: item.category3 === '완료' ? true : false,
        }));
        this.setDataList(updatedDataList);
        if (this.tableRef.current) {
          this.tableRef.current.resetData(updatedDataList);
        }
      }
    } catch (error) {
      this.modalService.errorAlert('조회 중 오류가 발생했습니다.', () => {});
    }
  }

  formatDateYYYYMMDD(value) {
    if (!value) return '';
    const year = value.substring(0, 4);
    const month = value.substring(4, 6);
    const day = value.substring(6, 8);
    return `${year}-${month}-${day}`;
  }

  async tableCellClick(info) {
    const rowData = this.tableRef.current.getRowObj(info.rowNo);
    if (info.key === 'print') {
      this.modalService.openModal('AnalysisReport', rowData, () => {});
    }
  }

  async searchParamChange(model, value) {
    this.setSearchParam(prev => ({ ...prev, [model]: value }));

    if (model === 'currentPage') {
      this.fnSearch(value);
    }
  }

  async handleChange(value) {
    this.setSearchParam(prev => ({ ...prev, seNm: value }));
  }
}

export default ReportListController;
